import React, { Component } from 'react';
import BlockR from './../BlockR';

var DateFilter = React.createClass({
  handlerSelect: function(data, name){
    var obj = { ...this.props.data }
    this.props.actionFilter(name, 'status');
    obj.statusData.select = data;
    this.props.actionDataFilter(obj)
  },
  render: function(){
    return(
      <div className="blockInside">
        <BlockR
          actionSelect={this.handlerSelect}
          filter={function(a){
            if(a.status === true || a.status === 'true' || a.status === 1 || a.status === "1"){
              return true
            }else{
              return false
            }

          }}
          select={this.props.data.statusData.select}
          id={0}
          name="Успех"
        />
        <BlockR
          actionSelect={this.handlerSelect}
          filter={function(a){
            if(a.status === false || a.status === 'false' || a.status === 2 || a.status === "2"){
              return true
            }else{
              return false
            }

          }}
          select={this.props.data.statusData.select}
          id={1}
          name="Отказ"
        />
        <BlockR
          actionSelect={this.handlerSelect}
          filter={function(a){
            if(a.status === 3 || a.status === "3"){
              return true
            }else{
              return false
            }

          }}
          select={this.props.data.statusData.select}
          id={2}
          name="Работает"
        />
        <BlockR
          actionSelect={this.handlerSelect}
          filter={function(a){
            if(a.status === 4 || a.status === "4"){
              return true
            }else{
              return false
            }

          }}
          select={this.props.data.statusData.select}
          id={3}
          name="Уволен"
        />
        <BlockR
          actionSelect={this.handlerSelect}
          filter={function(a){
            if(typeof a.status == 'undefined' || a.status === 0 || a.status === "0"){
              return true
            }else{
              return false
            }

          }}
          select={this.props.data.statusData.select}
          id={4}
          name="Новые"
        />
      </div>
    );
  }
});

export default DateFilter;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Filter/StatusFilter/index.jsx
 **/